import React from 'react'
import classNames from 'classnames'

import style from './Iframe.module.css'

function Iframe({ className, src, height, width, testId, ...rest }) {
  const containerStyle = {
    minHeight: height,
    minWidth: width
  }

  return (
    <div style={containerStyle} className={classNames(style.iframe, className)} data-testid={testId}>
      {src !== '' ? (
        <iframe src={src} width={width} height={height} {...rest}/>
      ) : (
        <span>Widget is available in production </span>
      )}
    </div>
  )
}

export default Iframe
